import React from 'react';
import { useParams } from 'react-router-dom';
import { getPostBySlug } from '../../utils/blogData';
import styles from './BlogPost.module.css';

const BlogPost: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getPostBySlug(slug) : undefined;

  if (!post) {
    return (
      <div className={styles.blogPost}>
        <div className={styles.container}>
          <h1>Post not found</h1>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.blogPost}>
      <div className={styles.container}>
        <article className={styles.article}>
          <h1 className={styles.title}>{post.title}</h1>
          <div className={styles.meta}>
            <span className={styles.date}>{new Date(post.date).toLocaleDateString()}</span>
          </div>
          {post.image && (
            <img src={post.image} alt={post.title} className={styles.image} />
          )}
          <div className={styles.content}>
            <p>{post.content}</p>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
